export default "__VITE_ASSET__Brazg2TJ__"